// extracted by mini-css-extract-plugin
export var bubble = "TextBubble-module--bubble--rFy8+";
export var dash = "TextBubble-module--dash--wrVfg";
export var first = "TextBubble-module--first--ETJQ3";
export var label = "TextBubble-module--label--9eBsG";
export var second = "TextBubble-module--second--4gbvZ";
export var text = "TextBubble-module--text--KTUCF";
export var texts = "TextBubble-module--texts--4scTj";
export var title = "TextBubble-module--title--qnmEB";
export var wrapper = "TextBubble-module--wrapper--pgtNY";